<template>
    <rkm-modal
        :loading="loading"
        large
        persistent
        ref="Modal"
        title="Importar permissões"
    >
        <rkm-form
            v-if="loaded"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        :validations="validations.unidade"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="form.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!form.unidadeId"
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="form.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="!form.infraestruturaId"
                        :options="centrosCusto"
                        :validations="validations.centroCusto"
                        label="Setor"
                        show-default-option
                        text-field="setorNome"
                        v-model="model.centroCustoOrigemId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.validate(save)"
                color="primary"
            >
                Importar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Others.
import { mapActions, mapGetters } from 'vuex'
import { repository, error, stringCase } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                unidade: {
                    required: true,
                },
                infraestrutura: {
                    required: true,
                },
                centroCusto: {
                    required: true,
                },
            }
        },
        infraestruturas() {

            if (this.form.unidadeId) {

                return this.form.unidades.find(u => u.id === this.form.unidadeId).infraestruturas
            }

            return []
        },
        centrosCusto() {

            if (this.form.infraestruturaId && this.infraestruturas.length > 0) {

                const infrasestrutura = this.infraestruturas.find(i => i.id === this.form.infraestruturaId)

                return infrasestrutura ? infrasestrutura.centrosCusto : []
            }

            return []
        }
    },
    created() {

        this.repositories = {
            permissao: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao.permissao')
        }
    },
    data: () => ({
        loaded: false,
        form: {},
        model: {},
        centroCustoDestino: null,
        unwatchers: {
            unwatchFormUnidadeId: null,
            unwatchFormInfraestruturaId: null,
            unwatchInfraestruturas: null,
            unwatchCentrosCusto: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(centroCustoDestino) {

            this.centroCustoDestino = centroCustoDestino

            this.load()
            this.$refs.Modal.show()
        },
        load() {

            this.setLoading()

            this.repositories.permissao.createImportacao(this.centroCustoDestino.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.unwatchers.unwatchFormUnidadeId = this.$watch('form.unidadeId', function () {

                this.form.infraestruturaId = null
            })

            this.unwatchers.unwatchFormInfraestruturaId = this.$watch('form.infraestruturaId', function () {

                this.model.centroCustoOrigemId = null
            })

            this.unwatchers.unwatchInfraestruturas = this.$watch('infraestruturas', function (infraestruturas) {

                if (infraestruturas.length === 1) {

                    this.form.infraestruturaId = infraestruturas[0].id
                }
            })

            this.unwatchers.unwatchCentrosCusto = this.$watch('centrosCusto', function (centrosCusto) {

                if (centrosCusto.length === 1) {

                    this.model.centroCustoOrigemId = centrosCusto[0].id
                }
            })
        },
        save() {

            const origem = this.centrosCusto.find(cc => cc.id === this.model.centroCustoOrigemId).setorNome
                + ` (Unidade: ${this.infraestruturas.find(i => i.id === this.form.infraestruturaId).nome}`
                + ` - Local de atendimento: ${this.form.unidades.find(u => u.id === this.form.unidadeId).nomeFantasia})`

            const destino = this.centroCustoDestino.setorNome
                + ` (Unidade: ${this.centroCustoDestino.infraestruturaNome}`
                + ` - Local de atendimento: ${this.centroCustoDestino.unidadeNomeFantasia})`

            this.showConfirmation(
                `Todas as permissões do setor ${destino} serão substituídas pelas permissões do setor ${origem}.
                    Deseja continuar?`,
                async () => {

                    this.$nextTick().then(() => {

                        this.showConfirmation(
                            `Deseja importar as parametrizações de estoque máximo do setor ${origem}?`,
                            async () => this.handleSave(true),
                            async () => this.handleSave(false)
                        )
                    })
                }
            )
        },
        handleSave(importarEstoqueMaximo) {

            const data = this.camelObjectKeysToSnakeRecursive({
                centroCustoOrigemId: this.model.centroCustoOrigemId,
                centroCustoDestinoId: this.centroCustoDestino.id,
                importarEstoqueMaximo
            })

            this.setLoading()

            this.repositories.permissao.storeImportacao(data)
                .then(() => {

                    this.showSaveNotification()
                    this.handleExit()

                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {

            this.unwatchers.unwatchFormUnidadeId()
            this.unwatchers.unwatchFormInfraestruturaId()
            this.unwatchers.unwatchInfraestruturas()
            this.unwatchers.unwatchCentrosCusto()

            this.loaded = false
            this.form = null
            this.model = null

            this.$refs.Modal.hide()
        },
    },
    mixins: [repository, error, stringCase],
}
</script>